import TaxListCountryHistoryData from "../../../../component/tax-types/tax-list/TaxListCountryHistoryData";

function TaxListCountryHistory() {
  return (
    <div className="page-body">
      <TaxListCountryHistoryData />
    </div>
  );
}

export default TaxListCountryHistory;
